import background1Src from '../assets/backgroundImages/background 1.webp'
import background1Print from '../assets/backgroundImages/background 1-print.webp'
import background2Src from '../assets/backgroundImages/background 2.webp'
import background2Print from '../assets/backgroundImages/background 2-print.webp'
import background3Src from '../assets/backgroundImages/background 3.webp'
import background3Print from '../assets/backgroundImages/background 3-print.webp'
import background4Src from '../assets/backgroundImages/background 4.webp'
import background4Print from '../assets/backgroundImages/background 4-print.webp'
import background5Src from '../assets/backgroundImages/background 5.webp'
import background5Print from '../assets/backgroundImages/background 5-print.webp'
import background6Src from '../assets/backgroundImages/background 6.webp'
import background6Print from '../assets/backgroundImages/background 6-print.webp'
import background7Src from '../assets/backgroundImages/background 7.webp'
import background7Print from '../assets/backgroundImages/background 7-print.webp'
import background8Src from '../assets/backgroundImages/background 8.webp'
import background8Print from '../assets/backgroundImages/background 8-print.webp'
import background9Src from '../assets/backgroundImages/background 9.webp'
import background9Print from '../assets/backgroundImages/background 9-print.webp'
import background10Src from '../assets/backgroundImages/background 10.webp'
import background10Print from '../assets/backgroundImages/background 10-print.webp'
import background11Src from '../assets/backgroundImages/background 11.webp'
import background11Print from '../assets/backgroundImages/background 11-print.webp'
import background12Src from '../assets/backgroundImages/background 12.webp'
import background12Print from '../assets/backgroundImages/background 12-print.webp'
import background13Src from '../assets/backgroundImages/background 13.webp'
import background13Print from '../assets/backgroundImages/background 13-print.webp'
import background14Src from '../assets/backgroundImages/background 14.webp'
import background14Print from '../assets/backgroundImages/background 14-print.webp'
import background15Src from '../assets/backgroundImages/background 15.webp'
import background15Print from '../assets/backgroundImages/background 15-print.webp'
import background16Src from '../assets/backgroundImages/background 16.webp'
import background16Print from '../assets/backgroundImages/background 16-print.webp'
import background17Src from '../assets/backgroundImages/background 17.webp'
import background17Print from '../assets/backgroundImages/background 17-print.webp'
import background18Src from '../assets/backgroundImages/background 18.webp'
import background18Print from '../assets/backgroundImages/background 18-print.webp'
import background19Src from '../assets/backgroundImages/background 19.webp'
import background19Print from '../assets/backgroundImages/background 19-print.webp'
import background20Src from '../assets/backgroundImages/background 20.webp'
import background20Print from '../assets/backgroundImages/background 20-print.webp'
import background21Src from '../assets/backgroundImages/background 21.webp'
import background21Print from '../assets/backgroundImages/background 21-print.webp'
import background22Src from '../assets/backgroundImages/background 22.webp'
import background22Print from '../assets/backgroundImages/background 22-print.webp'
import background23Src from '../assets/backgroundImages/background 23.webp'
import background23Print from '../assets/backgroundImages/background 23-print.webp'
import background24Src from '../assets/backgroundImages/background 24.webp'
import background24Print from '../assets/backgroundImages/background 24-print.webp'
import background25Src from '../assets/backgroundImages/background 25.webp'
import background25Print from '../assets/backgroundImages/background 25-print.webp'
import background26Src from '../assets/backgroundImages/background 26.webp'
import background26Print from '../assets/backgroundImages/background 26-print.webp'
import background27Src from '../assets/backgroundImages/background 27.webp'
import background27Print from '../assets/backgroundImages/background 27-print.webp'
import background28Src from '../assets/backgroundImages/background 28.webp'
import background28Print from '../assets/backgroundImages/background 28-print.webp'
import background29Src from '../assets/backgroundImages/background 29.webp'
import background29Print from '../assets/backgroundImages/background 29-print.webp'
import background30Src from '../assets/backgroundImages/background 30.webp'
import background30Print from '../assets/backgroundImages/background 30-print.webp'
import background31Src from '../assets/backgroundImages/background 31.webp'
import background31Print from '../assets/backgroundImages/background 31-print.webp'
import background32Src from '../assets/backgroundImages/background 32.webp'
import background32Print from '../assets/backgroundImages/background 32-print.webp'
import background33Src from '../assets/backgroundImages/background 33.webp'
import background33Print from '../assets/backgroundImages/background 33-print.webp'
import background34Src from '../assets/backgroundImages/background 34.webp'
import background34Print from '../assets/backgroundImages/background 34-print.webp'
import background35Src from '../assets/backgroundImages/background 35.webp'
import background35Print from '../assets/backgroundImages/background 35-print.webp'
import background36Src from '../assets/backgroundImages/background 36.webp'
import background36Print from '../assets/backgroundImages/background 36-print.webp'
import background37Src from '../assets/backgroundImages/background 37.webp'
import background37Print from '../assets/backgroundImages/background 37-print.webp'
import background38Src from '../assets/backgroundImages/background 38.webp'
import background38Print from '../assets/backgroundImages/background 38-print.webp'
import background39Src from '../assets/backgroundImages/background 39.webp'
import background39Print from '../assets/backgroundImages/background 39-print.webp'
import background40Src from '../assets/backgroundImages/background 40.webp'
import background40Print from '../assets/backgroundImages/background 40-print.webp'
import background41Src from '../assets/backgroundImages/background 41.webp'
import background41Print from '../assets/backgroundImages/background 41-print.webp'
import background42Src from '../assets/backgroundImages/background 42.webp'
import background42Print from '../assets/backgroundImages/background 42-print.webp'
import background43Src from '../assets/backgroundImages/background 43.webp'
import background43Print from '../assets/backgroundImages/background 43-print.webp'
import background44Src from '../assets/backgroundImages/background 44.webp'
import background44Print from '../assets/backgroundImages/background 44-print.webp'
import background45Src from '../assets/backgroundImages/background 45.webp'
import background45Print from '../assets/backgroundImages/background 45-print.webp'
import background46Src from '../assets/backgroundImages/background 46.webp'
import background46Print from '../assets/backgroundImages/background 46-print.webp'

export const BACKGROUND_SETS = [
  // Double page backgrounds
  {
    id: 101,
    type: 'double',
    labelKey: 'Background.doubleBackground1.label',
    defaultLabel: 'Purple and Diagonal Floral Double Background',
    images: [
      { src: background1Src, printSrc: background1Print, backgroundId: 1 },
      { src: background2Src, printSrc: background2Print, backgroundId: 2 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 102,
    type: 'double',
    labelKey: 'Background.doubleBackground2.label',
    defaultLabel: 'Misty Green Mountain Double Background',
    images: [
      { src: background33Src, printSrc: background33Print, backgroundId: 33 },
      { src: background34Src, printSrc: background34Print, backgroundId: 34 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 103,
    type: 'double',
    labelKey: 'Background.doubleBackground3.label',
    defaultLabel: 'Teal and Yellow Gradient Double Background',
    images: [
      { src: background35Src, printSrc: background35Print, backgroundId: 35 },
      { src: background36Src, printSrc: background36Print, backgroundId: 36 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 104,
    type: 'double',
    labelKey: 'Background.doubleBackground4.label',
    defaultLabel: 'Blue Arctic Reflection Double Background',
    images: [
      { src: background37Src, printSrc: background37Print, backgroundId: 37 },
      { src: background38Src, printSrc: background38Print, backgroundId: 38 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 105,
    type: 'double',
    labelKey: 'Background.doubleBackground5.label',
    defaultLabel: 'Minimal Mountain Line Art Double Background',
    images: [
      { src: background39Src, printSrc: background39Print, backgroundId: 39 },
      { src: background40Src, printSrc: background40Print, backgroundId: 40 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 106,
    type: 'double',
    labelKey: 'Background.doubleBackground6.label',
    defaultLabel: 'Beige and Teal Abstract Curves Double Background',
    images: [
      { src: background41Src, printSrc: background41Print, backgroundId: 41 },
      { src: background42Src, printSrc: background42Print, backgroundId: 42 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 107,
    type: 'double',
    labelKey: 'Background.doubleBackground7.label',
    defaultLabel: 'Dark Teal Aurora Double Background',
    images: [
      { src: background14Src, printSrc: background14Print, backgroundId: 14 },
      { src: background15Src, printSrc: background15Print, backgroundId: 15 },
    ],
    hasDarkBackground: true,
  },
  {
    id: 108,
    type: 'double',
    labelKey: 'Background.doubleBackground8.label',
    defaultLabel: 'Pastel Botanical Abstract Double Background',
    images: [
      { src: background43Src, printSrc: background43Print, backgroundId: 43 },
      { src: background44Src, printSrc: background44Print, backgroundId: 44 },
    ],
    hasDarkBackground: false,
  },
  {
    id: 109,
    type: 'double',
    labelKey: 'Background.doubleBackground9.label',
    defaultLabel: 'Soft Pastel Color Block Double Background',
    images: [
      { src: background45Src, printSrc: background45Print, backgroundId: 45 },
      { src: background46Src, printSrc: background46Print, backgroundId: 46 },
    ],
    hasDarkBackground: false,
  },
  // Single page backgrounds
  {
    id: 1,
    type: 'single',
    labelKey: 'Background.background1.label',
    defaultLabel: 'Purple Floral Watercolor Background',
    images: [{ src: background1Src, printSrc: background1Print }],
    hasDarkBackground: false,
  },
  {
    id: 2,
    type: 'single',
    labelKey: 'Background.background2.label',
    defaultLabel: 'Diagonal Floral Watercolor Background',
    images: [{ src: background2Src, printSrc: background2Print }],
    hasDarkBackground: false,
  },
  {
    id: 3,
    type: 'single',
    labelKey: 'Background.background3.label',
    defaultLabel: 'Blush and Gold Watercolor Background',
    images: [{ src: background3Src, printSrc: background3Print }],
    hasDarkBackground: false,
  },
  {
    id: 4,
    type: 'single',
    labelKey: 'Background.background4.label',
    defaultLabel: 'Blush Botanical Watercolor Background',
    images: [{ src: background4Src, printSrc: background4Print }],
    hasDarkBackground: false,
  },
  {
    id: 5,
    type: 'single',
    labelKey: 'Background.background5.label',
    defaultLabel: 'Blush and Gray Botanical Watercolor Background',
    images: [{ src: background5Src, printSrc: background5Print }],
    hasDarkBackground: false,
  },
  {
    id: 6,
    type: 'single',
    labelKey: 'Background.background6.label',
    defaultLabel: 'Pastel Crescent with Sparkling Stars',
    images: [{ src: background6Src, printSrc: background6Print }],
    hasDarkBackground: false,
  },
  {
    id: 7,
    type: 'single',
    labelKey: 'Background.background7.label',
    defaultLabel: 'Iridescent Sphere Background',
    images: [{ src: background7Src, printSrc: background7Print }],
    hasDarkBackground: false,
  },
  {
    id: 8,
    type: 'single',
    labelKey: 'Background.background8.label',
    defaultLabel: 'Iridescent Diagonal Disc Background',
    images: [{ src: background8Src, printSrc: background8Print }],
    hasDarkBackground: false,
  },
  {
    id: 9,
    type: 'single',
    labelKey: 'Background.background9.label',
    defaultLabel: 'Iridescent Bubbles Background',
    images: [{ src: background9Src, printSrc: background9Print }],
    hasDarkBackground: false,
  },
  {
    id: 10,
    type: 'single',
    labelKey: 'Background.background10.label',
    defaultLabel: 'Blue Gradient With Orange Accents Background',
    images: [{ src: background10Src, printSrc: background10Print }],
    hasDarkBackground: true,
  },
  {
    id: 11,
    type: 'single',
    labelKey: 'Background.background11.label',
    defaultLabel: 'Orange Triangle with Blue Gradient Background',
    images: [{ src: background11Src, printSrc: background11Print }],
    hasDarkBackground: true,
  },
  {
    id: 12,
    type: 'single',
    labelKey: 'Background.background12.label',
    defaultLabel: 'Blue and Orange Diagonal Gradient Background',
    images: [{ src: background12Src, printSrc: background12Print }],
    hasDarkBackground: true,
  },
  {
    id: 13,
    type: 'single',
    labelKey: 'Background.background13.label',
    defaultLabel: 'Orange Spot on Dark Blue Gradient Background',
    images: [{ src: background13Src, printSrc: background13Print }],
    hasDarkBackground: true,
  },
  {
    id: 14,
    type: 'single',
    labelKey: 'Background.background14.label',
    defaultLabel: 'Green Northern Lights Background',
    images: [{ src: background14Src, printSrc: background14Print }],
    hasDarkBackground: true,
  },
  {
    id: 15,
    type: 'single',
    labelKey: 'Background.background15.label',
    defaultLabel: 'Blue Northern Lights Background',
    images: [{ src: background15Src, printSrc: background15Print }],
    hasDarkBackground: true,
  },
  {
    id: 16,
    type: 'single',
    labelKey: 'Background.background16.label',
    defaultLabel: 'Magenta Wave Background',
    images: [{ src: background16Src, printSrc: background16Print }],
    hasDarkBackground: true,
  },
  {
    id: 17,
    type: 'single',
    labelKey: 'Background.background17.label',
    defaultLabel: 'Pink and Blue Diagonal Background',
    images: [{ src: background17Src, printSrc: background17Print }],
    hasDarkBackground: true,
  },
  {
    id: 18,
    type: 'single',
    labelKey: 'Background.background18.label',
    defaultLabel: 'Navy and Teal Gradient Background',
    images: [{ src: background18Src, printSrc: background18Print }],
    hasDarkBackground: true,
  },
  {
    id: 19,
    type: 'single',
    labelKey: 'Background.background19.label',
    defaultLabel: 'Teal Squiggle Background',
    images: [{ src: background19Src, printSrc: background19Print }],
    hasDarkBackground: true,
  },
  {
    id: 20,
    type: 'single',
    labelKey: 'Background.background20.label',
    defaultLabel: 'Green Squiggle Background',
    images: [{ src: background20Src, printSrc: background20Print }],
    hasDarkBackground: true,
  },
  {
    id: 21,
    type: 'single',
    labelKey: 'Background.background21.label',
    defaultLabel: 'Gray Zebra Stripe Background',
    images: [{ src: background21Src, printSrc: background21Print }],
    hasDarkBackground: true,
  },
  {
    id: 22,
    type: 'single',
    labelKey: 'Background.background22.label',
    defaultLabel: 'Pink Zebra Stripe Background',
    images: [{ src: background22Src, printSrc: background22Print }],
    hasDarkBackground: true,
  },
  {
    id: 23,
    type: 'single',
    labelKey: 'Background.background23.label',
    defaultLabel: 'Lilac Bottom Banner Background',
    images: [{ src: background23Src, printSrc: background23Print }],
    hasDarkBackground: false,
  },
  {
    id: 24,
    type: 'single',
    labelKey: 'Background.background24.label',
    defaultLabel: 'Teal Gradient Watercolor Background',
    images: [{ src: background24Src, printSrc: background24Print }],
    hasDarkBackground: false,
  },
  {
    id: 25,
    type: 'single',
    labelKey: 'Background.background25.label',
    defaultLabel: 'Blush Gradient Background',
    images: [{ src: background25Src, printSrc: background25Print }],
    hasDarkBackground: false,
  },
  {
    id: 26,
    type: 'single',
    labelKey: 'Background.background26.label',
    defaultLabel: 'Pastel Gradient Background',
    images: [{ src: background26Src, printSrc: background26Print }],
    hasDarkBackground: false,
  },
  {
    id: 27,
    type: 'single',
    labelKey: 'Background.background27.label',
    defaultLabel: 'Gray With White Polka Dot Background',
    images: [{ src: background27Src, printSrc: background27Print }],
    hasDarkBackground: false,
  },
  {
    id: 28,
    type: 'single',
    labelKey: 'Background.background28.label',
    defaultLabel: 'Gray With White Polka Dot With Star Background',
    images: [{ src: background28Src, printSrc: background28Print }],
    hasDarkBackground: false,
  },
  {
    id: 29,
    type: 'single',
    labelKey: 'Background.background29.label',
    defaultLabel: 'Light Green With White Polka Dot Background',
    images: [{ src: background29Src, printSrc: background29Print }],
    hasDarkBackground: false,
  },
  {
    id: 30,
    type: 'single',
    labelKey: 'Background.background30.label',
    defaultLabel: 'Light Pink With White Polka Dot Background',
    images: [{ src: background30Src, printSrc: background30Print }],
    hasDarkBackground: false,
  },
  {
    id: 31,
    type: 'single',
    labelKey: 'Background.background31.label',
    defaultLabel: 'White Background',
    images: [{ src: background31Src, printSrc: background31Print }],
    hasDarkBackground: false,
  },
  {
    id: 32,
    type: 'single',
    labelKey: 'Background.background32.label',
    defaultLabel: 'Black Background',
    images: [{ src: background32Src, printSrc: background32Print }],
    hasDarkBackground: true,
  },
  {
    id: 33,
    type: 'single',
    labelKey: 'Background.background33.label',
    defaultLabel: 'Misty Green Mountain with Pine Tree Left',
    images: [{ src: background33Src, printSrc: background33Print }],
    hasDarkBackground: false,
  },
  {
    id: 34,
    type: 'single',
    labelKey: 'Background.background34.label',
    defaultLabel: 'Misty Green Mountain with Pine Trees Right',
    images: [{ src: background34Src, printSrc: background34Print }],
    hasDarkBackground: false,
  },
  {
    id: 35,
    type: 'single',
    labelKey: 'Background.background35.label',
    defaultLabel: 'Teal to Yellow Diagonal Gradient Background',
    images: [{ src: background35Src, printSrc: background35Print }],
    hasDarkBackground: false,
  },
  {
    id: 36,
    type: 'single',
    labelKey: 'Background.background36.label',
    defaultLabel: 'Yellow Textured Gradient Background',
    images: [{ src: background36Src, printSrc: background36Print }],
    hasDarkBackground: false,
  },
  {
    id: 37,
    type: 'single',
    labelKey: 'Background.background37.label',
    defaultLabel: 'Blue Arctic Mountain Reflection Background',
    images: [{ src: background37Src, printSrc: background37Print }],
    hasDarkBackground: false,
  },
  {
    id: 38,
    type: 'single',
    labelKey: 'Background.background38.label',
    defaultLabel: 'Blue Arctic Mountain Reflection Mirrored Background',
    images: [{ src: background38Src, printSrc: background38Print }],
    hasDarkBackground: false,
  },
  {
    id: 39,
    type: 'single',
    labelKey: 'Background.background39.label',
    defaultLabel: 'Minimal Gray Mountain with Line Details Background',
    images: [{ src: background39Src, printSrc: background39Print }],
    hasDarkBackground: false,
  },
  {
    id: 40,
    type: 'single',
    labelKey: 'Background.background40.label',
    defaultLabel: 'Minimal Gray Mountain with Wave Lines Background',
    images: [{ src: background40Src, printSrc: background40Print }],
    hasDarkBackground: false,
  },
  {
    id: 41,
    type: 'single',
    labelKey: 'Background.background41.label',
    defaultLabel: 'Beige and Teal Abstract Curves Background',
    images: [{ src: background41Src, printSrc: background41Print }],
    hasDarkBackground: false,
  },
  {
    id: 42,
    type: 'single',
    labelKey: 'Background.background42.label',
    defaultLabel: 'Teal and Beige Abstract Curves Background',
    images: [{ src: background42Src, printSrc: background42Print }],
    hasDarkBackground: false,
  },
  {
    id: 43,
    type: 'single',
    labelKey: 'Background.background43.label',
    defaultLabel: 'Pastel Abstract with Botanical Line Art Background',
    images: [{ src: background43Src, printSrc: background43Print }],
    hasDarkBackground: false,
  },
  {
    id: 44,
    type: 'single',
    labelKey: 'Background.background44.label',
    defaultLabel: 'Pastel Botanical Abstract with Line Art Background',
    images: [{ src: background44Src, printSrc: background44Print }],
    hasDarkBackground: false,
  },
  {
    id: 45,
    type: 'single',
    labelKey: 'Background.background45.label',
    defaultLabel: 'Soft Pastel Color Blocks Background',
    images: [{ src: background45Src, printSrc: background45Print }],
    hasDarkBackground: false,
  },
  {
    id: 46,
    type: 'single',
    labelKey: 'Background.background46.label',
    defaultLabel: 'Soft Pastel Color Blocks Complementary Background',
    images: [{ src: background46Src, printSrc: background46Print }],
    hasDarkBackground: false,
  },
]

export const BACKGROUND_OPTIONS = BACKGROUND_SETS.filter((set) => set.type === 'single').map((set) => ({
  id: set.id,
  labelKey: set.labelKey,
  defaultLabel: set.defaultLabel,
  src: set.images[0].src,
  printSrc: set.images[0].printSrc,
  hasDarkBackground: set.hasDarkBackground,
}))

export const BACKGROUND_OPTIONS_BY_ID = BACKGROUND_OPTIONS.reduce((accumulator, option) => {
  accumulator[option.id] = option
  return accumulator
}, {})

export const BLANK_BACKGROUND_ID = 31
